<template>
    <v-container fluid>
      <v-row>
        <v-col cols="8" sm="6" md="6">
          <v-text-field
            v-model="searchDocNo"
            outlined
            label="Search by Document No"
            @input="fetchCollectionList"
          ></v-text-field>
        </v-col>
        <!-- Refresh Button -->
        <v-col cols="2" sm="2" md="2">
          <v-btn class="ml-2 mt-1" fab dark small color="primary" @click="fetchCollectionList">
            <v-icon dark>mdi-refresh</v-icon>
          </v-btn>
        </v-col>

        <!-- Date Filter Button -->
        <v-col cols="2" sm="2" md="2">
          <v-btn class="ml-2 mt-1" fab dark small color="primary" @click="showDateFilter">
            <v-icon>mdi-calendar-range</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <!-- Date Filter Row -->
      <v-row v-if="dateFilterVisible">
        <!-- From Date Picker -->
        <v-col cols="6" sm="4" md="6">
          <v-dialog ref="dialog1" v-model="modal1" :return-value.sync="fromDate" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="fromDate" label="From Date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="fromDate" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal1 = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.dialog1.save(fromDate)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <!-- To Date Picker -->
        <v-col cols="6" sm="4" md="6">
          <v-dialog ref="dialog" v-model="modal" :return-value.sync="toDate" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="toDate" label="To Date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="toDate" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.dialog.save(toDate)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>
      <!-- Customer Search -->
      <v-autocomplete
        v-model="selectedCustomer"
        :items="filteredCustomers"
        item-text="desc"
        item-value="docno"
        label="Search Customer"
        return-object
        :loading="isLoadingCustomers"
        @change="onCustomerChange" 
        outlined
      >
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title v-text="item.desc"></v-list-item-title>
            <v-list-item-subtitle v-text="item.displayName"></v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <template v-slot:no-data>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                No Data Available - 
                <span @click="triggerCustomerSearch" style="color: blue; cursor:pointer;">Search on Server</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-for="item in collectionList.items"
          :key="item.RP_DOCNO"
        >
          <v-card>
            <v-card-title>
              {{ item.RP_DOCNO }}
              <v-icon v-if="item.RP_POSTED_BY" 
                color="green">
                mdi-check
              </v-icon> 
              <v-spacer></v-spacer>              
              <v-btn color="primary"
                fab 
                dark 
                small
                @click="fetchDetails(item.RP_DOCNO)">
                <v-icon > mdi-eye</v-icon>
              </v-btn>            
            </v-card-title>   
            <v-card-text>             
               {{ item.RP_PAID_TO }}<br>
               <v-divider></v-divider>
               {{ item.RP_NARRATION }}<br>
               <v-divider></v-divider>
               {{ item.RP_CREATED_TS }}<br>
               <v-divider></v-divider>
               Created by: {{ item.RP_CREATED_BY }}
              <!-- Add more fields as needed -->
            </v-card-text>
            <!-- <v-card-actions>
              <v-btn color="primary" @click="fetchDetails(item.RP_DOCNO)">
                <v-icon > mdi-eye</v-icon>
                Allocation Details
              </v-btn>
            </v-card-actions> -->
          </v-card>
        </v-col>
      </v-row>
      <v-pagination
        v-model="collectionList.page"
        :length="collectionList.totalPages"
        @input="fetchCollectionList"
      ></v-pagination>

      <v-dialog v-model="detailsDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            Allocation Details
            <v-spacer></v-spacer>
            <v-btn icon @click="detailsDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div v-for="detail in collectionDetails" :key="detail.RPADET_DOCSRNO">
              InvoiceNo: {{ detail.RPADET_BEFORE_DOCNO }}<br>
              Amount: {{ detail.RPADET_AMOUNT }} --
              Balance: {{ detail.RPADET_SHOW_BAL_FCAMOUNT }}
              <v-divider></v-divider>
              <!-- Add more fields as needed -->
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </template>
  
  <script>
  import secure_axios from "../services/secure_axios";
  export default {
    data() {
      const startOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10);
      const today = new Date().toISOString().slice(0, 10);
      return {
        searchDocNo: '',
        selectedCustomer: null,
        isLoadingCustomers: false,
        isSearchingCustomers: false,
        collectionList: {
          items: [],
          page: 1,
          perPage: 10,
          total: 0,
          totalPages: 0, // Add this line
        },
        collectionDetails: [],
        detailsDialog: false,
        dateFilterVisible: false,
        fromDate: startOfMonth,
        toDate: today,
        modal1: false,
        modal: false,
      };
    },
    computed: {
      user() {
        return this.$store.getters.factsuser; // for getting user name this.user?.USER_LOGINID
      },
      perferedAPI() {
        return this.$store.getters.perferedAPI; // default API
      },
      filteredCustomers() {
        if (!this.searchTerm) return this.customers;
        return this.customers.filter(customer =>
          customer.desc.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          customer.docno.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
      },
    },
    methods: {
      onCustomerChange(selectedCustomer) {
        if (selectedCustomer) {
          this.fetchCollectionList(selectedCustomer.docno, selectedCustomer.doctype);
        } else {
          this.fetchCollectionList();
        }
      },
      showDateFilter() {
        this.dateFilterVisible = !this.dateFilterVisible;
      },
      onSearchInput(input) {
        console.log("onSearchInput",input)
        this.searchTerm = input;
        // this.debounceSearch();
      },
      triggerCustomerSearch() {
        // console.log('hello Search on Server ')
        // console.log('search',this.searchTerm);
        if (!this.searchTerm) return;
        this.isLoadingCustomers = true;
        // console.log('hello Search on Server ')

        secure_axios.get(`${this.perferedAPI}customers/search?term=${this.searchTerm}`)
          .then((response) => {
            // Assuming the server returns an array of customers
            if(response.data.length > 0) {
              const newCustomers = response.data.filter(newCustomer => 
                !this.customers.some(existingCustomer => 
                  existingCustomer.docno === newCustomer.docno && existingCustomer.doctype === newCustomer.doctype
                )
              )
              // Then, map each new customer to add the displayName field
              .map(customer => ({
                ...customer,
                displayName: `${customer.doctype} - ${customer.docno}`,
              }));
              // Append new customers to the existing list
              this.customers = [...this.customers, ...newCustomers];
            } else {
              // Handle no results from server, e.g., show a message or log
              console.log("No customers found on server.");
            }
            this.isLoadingCustomers = false;
          })
          .catch((error) => {
          console.error("Error fetching customers from server:", error);
          this.isLoadingCustomers = false;
        });
      },
      customerFilter(items, search) {
        search = search.toLowerCase();
        return items.filter(item => 
          item.PARTYMST_DESC.toLowerCase().includes(search) ||
          item.PARTYMST_DOCNO.toLowerCase().includes(search)
        );
      },
      fetchCollectionList(docno = '', doctype = '') {
        let apiURL = `${this.perferedAPI}/collections?page=${this.collectionList.page}&per_page=${this.collectionList.perPage}`;
        if (this.user?.USER_LOGINID) {
          apiURL += `&created_by=${this.user.USER_LOGINID}`;
        }
        if (this.user?.USER_DEFAULT_SMAN_DOCNO) {
          apiURL += `&smanNo=${this.USER_DEFAULT_SMAN_DOCNO}`;
        }
        if (docno && doctype) {
          apiURL += `&docno=${docno}&doctype=${doctype}`;
        }
        if (this.searchDocNo) {
          apiURL += `&rpdocno=${this.searchDocNo}`;
        }

         // Include fromDate and toDate in the API call
        if (this.fromDate) {
          apiURL += `&fromDate=${this.fromDate}`;
        }
        if (this.toDate) {
          apiURL += `&toDate=${this.toDate}`;
        }

        secure_axios
          .get(apiURL)
          .then((response) => {            
            this.collectionList.items = response.data.headers;
            this.collectionList.total = response.data.total;
            this.collectionList.totalPages = Math.ceil(response.data.total / this.collectionList.perPage);
          })
          .catch((error) => {
            console.error("Error fetching BRVAR list:", error);
          });
      },
      fetchDetails(docno) {
        const apiURL = `${this.perferedAPI}/allocations?docno=${docno}`;
        secure_axios
          .get(apiURL)
          .then((response) => {
            console.log(response.data);
            this.collectionDetails = response.data;
            this.detailsDialog = true;
          })
          .catch((error) => {
            console.error("Error fetching BRVAR details:", error);
          });
      },
    },
    mounted() {
      this.fetchCollectionList();
    },
  };
  </script>
  